export default function injectComponentScript(endpoint: string){
  if(document.querySelector(`script[src='${endpoint}']`)){
    return;
  }

  const s: HTMLScriptElement = document.createElement('script');
  s.src = endpoint;
  s.text = ``;

  if(endpoint.includes('.esm.js')) {
    s.type = 'module'
  } else {
    s.noModule = true;
  }

  document.head.appendChild(s);
}
